// extracted by mini-css-extract-plugin
export default {"SpinLoding":"SpinLoding_SpinLoding__Dsa2k"};